import * as moment from 'moment';
import { Model } from './model';
import { AnnuncioAllegato } from './annuncio-allegato';

export class Annuncio extends Model {
  static apiUrl = 'annunci';

  titolo: string;
  contenuto: string;
  readAt?: moment.Moment;
  isRead?: boolean;
  allegati: AnnuncioAllegato[] = [];

  deserialize(input: any): Annuncio {
    let retV: Annuncio = new Annuncio();
    retV = super.deserialize(input) as Annuncio;
    retV.isRead = !!input?.is_read;
    retV.readAt = input?.read_at ? moment(input.read_at) : undefined;
    if (input?.allegati) {
      retV.allegati = input.allegati.map((a: any) => new AnnuncioAllegato().deserialize(a));
    }
    return retV;
  }

  public getHumanIdentifier() {
    return this.titolo;
  }

  static getDefaultSortKey() {
    return 'created_at';
  }
}
